module.exports = __webpack_public_path__ + "static/img/headerBg.de269d8f.png";